import RuleModel from '@/models/RuleModel'

export default {
	SET_RULE (state, value) {
		state.rule = new RuleModel(value.data)
	}
}
